module.exports = __webpack_public_path__ + "img/Misc_Twitter_RoundedSquare.c2f1acf6.svg";